import { CheckOutlined } from '@ant-design/icons';
const ActiveImg = () => {
    return <CheckOutlined className="active-img" />;
};
export default ActiveImg;
